import PropTypes from 'prop-types';
import React, { createContext, useContext } from 'react';
const headerBarContext = /*#__PURE__*/createContext({
  updateAvailable: false,
  onApplyAvailableUpdate: () => {}
});
export const HeaderBarContextProvider = _ref => {
  let {
    updateAvailable,
    onApplyAvailableUpdate,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(headerBarContext.Provider, {
    value: {
      updateAvailable,
      onApplyAvailableUpdate
    }
  }, children);
};
HeaderBarContextProvider.propTypes = {
  children: PropTypes.node,
  updateAvailable: PropTypes.bool,
  onApplyAvailableUpdate: PropTypes.func
};
export const useHeaderBarContext = () => useContext(headerBarContext);